import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-2 text-pri text-2xl font-bold" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "mb-3 ml-3" }
const _hoisted_4 = {
  key: 0,
  class: "border-r border-solid border-gray-300 bay-occupied"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  width: "35",
  height: "56",
  viewBox: "0 0 35 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.0278106 13.6968C0.0948265 14.0621 0.0786503 13.9741 0.18187 14.5216C0.229629 14.7817 0.289712 15.0983 0.80196 15.0024C1.58073 14.861 2.96418 14.4054 3.52265 14.2003C3.57965 14.1776 3.63665 14.1571 3.6952 14.1375L3.6952 50.4278C3.6952 51.629 5.0386 56 9.53713 56L26.7186 56C30.9406 56 31.2087 51.629 31.2087 50.4278L31.2087 14.1037C31.2988 14.1359 31.3889 14.1666 31.476 14.2003C32.0352 14.4062 33.4179 14.8618 34.1974 15.0024C34.7105 15.0983 34.7705 14.7817 34.8191 14.5216C34.9207 13.9741 34.9038 14.0621 34.9724 13.6968C35.2782 12.0627 32.9727 11.8569 32.9727 11.8569L31.1324 11.4995C30.8289 8.00438 29.407 -0.000779484 23.0066 -0.000779204L11.8966 -0.000778718C6.05077 -0.000778463 4.26984 8.01696 3.82384 11.5081L2.0275 11.8577C2.0275 11.8577 -0.277227 12.0627 0.0278106 13.6968ZM26.1255 51.4451C23.4079 51.9668 11.5946 51.9668 8.87622 51.4451C8.26922 51.3289 7.87021 50.8497 7.97805 50.4129C8.30928 49.0059 8.63974 47.5997 8.97251 46.1943L26.03 46.1943C26.362 47.5997 26.6917 49.0059 27.0237 50.4129C27.1307 50.8497 26.7302 51.3289 26.1255 51.4451ZM29.2891 47.2438L26.6038 43.9349L26.6038 35.9675L29.2891 35.9675L29.2891 47.2438ZM29.2891 34.5597L26.6038 34.5597L26.6038 21.9337L29.2891 18.6256L29.2891 34.5597ZM23.0512 1.41721C25.4723 1.41721 26.828 2.98604 27.5806 4.96572C27.4727 5.23675 27.2879 5.47321 26.7579 5.29567C25.7789 4.96572 24.0788 4.11964 23.3932 3.74413C22.616 3.32227 21.6416 2.96796 21.352 1.41721L23.0512 1.41721ZM11.9489 1.41721L13.6482 1.41721C13.3593 2.96796 12.3842 3.32227 11.6069 3.74413C10.9206 4.11964 9.22054 4.96572 8.24226 5.29567C7.7123 5.474 7.5282 5.23675 7.41804 4.96572C8.17216 2.98604 9.52943 1.41721 11.9489 1.41721ZM7.96264 10.6557C12.2108 9.84423 22.7886 9.84423 27.036 10.6557C27.9827 10.838 28.6074 11.5859 28.4395 12.2725C27.911 14.5138 27.3842 16.7566 26.855 19.0011C26.6878 19.6845 26.0038 20.1033 25.3198 19.9728C22.2062 19.3758 12.794 19.3758 9.67887 19.9728C8.99561 20.1033 8.31236 19.6845 8.14366 19.0011C7.61524 16.7574 7.08682 14.5138 6.55916 12.2725C6.39201 11.5859 7.01672 10.8388 7.96264 10.6557ZM5.7103 18.6256L8.39555 21.9337L8.39555 34.5597L5.7103 34.5597L5.7103 18.6256ZM5.7103 35.9682L8.39555 35.9682L8.39555 43.9349L5.7103 47.2438L5.7103 35.9682Z",
    fill: "#1E40AF"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "border-r border-solid border-gray-300 bay-charging"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  width: "35",
  height: "56",
  viewBox: "0 0 35 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.0278106 13.6968C0.0948265 14.0621 0.0786503 13.9741 0.18187 14.5216C0.229629 14.7817 0.289712 15.0983 0.80196 15.0024C1.58073 14.861 2.96418 14.4054 3.52265 14.2003C3.57965 14.1776 3.63665 14.1571 3.6952 14.1375L3.6952 50.4278C3.6952 51.629 5.0386 56 9.53713 56L26.7186 56C30.9406 56 31.2087 51.629 31.2087 50.4278L31.2087 14.1037C31.2988 14.1359 31.3889 14.1666 31.476 14.2003C32.0352 14.4062 33.4179 14.8618 34.1974 15.0024C34.7105 15.0983 34.7705 14.7817 34.8191 14.5216C34.9207 13.9741 34.9038 14.0621 34.9724 13.6968C35.2782 12.0627 32.9727 11.8569 32.9727 11.8569L31.1324 11.4995C30.8289 8.00438 29.407 -0.000779484 23.0066 -0.000779204L11.8966 -0.000778718C6.05077 -0.000778463 4.26984 8.01696 3.82384 11.5081L2.0275 11.8577C2.0275 11.8577 -0.277227 12.0627 0.0278106 13.6968ZM26.1255 51.4451C23.4079 51.9668 11.5946 51.9668 8.87622 51.4451C8.26922 51.3289 7.87021 50.8497 7.97805 50.4129C8.30928 49.0059 8.63974 47.5997 8.97251 46.1943L26.03 46.1943C26.362 47.5997 26.6917 49.0059 27.0237 50.4129C27.1307 50.8497 26.7302 51.3289 26.1255 51.4451ZM29.2891 47.2438L26.6038 43.9349L26.6038 35.9675L29.2891 35.9675L29.2891 47.2438ZM29.2891 34.5597L26.6038 34.5597L26.6038 21.9337L29.2891 18.6256L29.2891 34.5597ZM23.0512 1.41721C25.4723 1.41721 26.828 2.98604 27.5806 4.96572C27.4727 5.23675 27.2879 5.47321 26.7579 5.29567C25.7789 4.96572 24.0788 4.11964 23.3932 3.74413C22.616 3.32227 21.6416 2.96796 21.352 1.41721L23.0512 1.41721ZM11.9489 1.41721L13.6482 1.41721C13.3593 2.96796 12.3842 3.32227 11.6069 3.74413C10.9206 4.11964 9.22054 4.96572 8.24226 5.29567C7.7123 5.474 7.5282 5.23675 7.41804 4.96572C8.17216 2.98604 9.52943 1.41721 11.9489 1.41721ZM7.96264 10.6557C12.2108 9.84423 22.7886 9.84423 27.036 10.6557C27.9827 10.838 28.6074 11.5859 28.4395 12.2725C27.911 14.5138 27.3842 16.7566 26.855 19.0011C26.6878 19.6845 26.0038 20.1033 25.3198 19.9728C22.2062 19.3758 12.794 19.3758 9.67887 19.9728C8.99561 20.1033 8.31236 19.6845 8.14366 19.0011C7.61524 16.7574 7.08682 14.5138 6.55916 12.2725C6.39201 11.5859 7.01672 10.8388 7.96264 10.6557ZM5.7103 18.6256L8.39555 21.9337L8.39555 34.5597L5.7103 34.5597L5.7103 18.6256ZM5.7103 35.9682L8.39555 35.9682L8.39555 43.9349L5.7103 47.2438L5.7103 35.9682Z",
    fill: "#10B981"
  })
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "border-r border-solid border-gray-300 bay-available"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  width: "35",
  height: "56",
  viewBox: "0 0 35 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.0278106 13.6968C0.0948265 14.0621 0.0786503 13.9741 0.18187 14.5216C0.229629 14.7817 0.289712 15.0983 0.80196 15.0024C1.58073 14.861 2.96418 14.4054 3.52265 14.2003C3.57965 14.1776 3.63665 14.1571 3.6952 14.1375L3.6952 50.4278C3.6952 51.629 5.0386 56 9.53713 56L26.7186 56C30.9406 56 31.2087 51.629 31.2087 50.4278L31.2087 14.1037C31.2988 14.1359 31.3889 14.1666 31.476 14.2003C32.0352 14.4062 33.4179 14.8618 34.1974 15.0024C34.7105 15.0983 34.7705 14.7817 34.8191 14.5216C34.9207 13.9741 34.9038 14.0621 34.9724 13.6968C35.2782 12.0627 32.9727 11.8569 32.9727 11.8569L31.1324 11.4995C30.8289 8.00438 29.407 -0.000779484 23.0066 -0.000779204L11.8966 -0.000778718C6.05077 -0.000778463 4.26984 8.01696 3.82384 11.5081L2.0275 11.8577C2.0275 11.8577 -0.277227 12.0627 0.0278106 13.6968ZM26.1255 51.4451C23.4079 51.9668 11.5946 51.9668 8.87622 51.4451C8.26922 51.3289 7.87021 50.8497 7.97805 50.4129C8.30928 49.0059 8.63974 47.5997 8.97251 46.1943L26.03 46.1943C26.362 47.5997 26.6917 49.0059 27.0237 50.4129C27.1307 50.8497 26.7302 51.3289 26.1255 51.4451ZM29.2891 47.2438L26.6038 43.9349L26.6038 35.9675L29.2891 35.9675L29.2891 47.2438ZM29.2891 34.5597L26.6038 34.5597L26.6038 21.9337L29.2891 18.6256L29.2891 34.5597ZM23.0512 1.41721C25.4723 1.41721 26.828 2.98604 27.5806 4.96572C27.4727 5.23675 27.2879 5.47321 26.7579 5.29567C25.7789 4.96572 24.0788 4.11964 23.3932 3.74413C22.616 3.32227 21.6416 2.96796 21.352 1.41721L23.0512 1.41721ZM11.9489 1.41721L13.6482 1.41721C13.3593 2.96796 12.3842 3.32227 11.6069 3.74413C10.9206 4.11964 9.22054 4.96572 8.24226 5.29567C7.7123 5.474 7.5282 5.23675 7.41804 4.96572C8.17216 2.98604 9.52943 1.41721 11.9489 1.41721ZM7.96264 10.6557C12.2108 9.84423 22.7886 9.84423 27.036 10.6557C27.9827 10.838 28.6074 11.5859 28.4395 12.2725C27.911 14.5138 27.3842 16.7566 26.855 19.0011C26.6878 19.6845 26.0038 20.1033 25.3198 19.9728C22.2062 19.3758 12.794 19.3758 9.67887 19.9728C8.99561 20.1033 8.31236 19.6845 8.14366 19.0011C7.61524 16.7574 7.08682 14.5138 6.55916 12.2725C6.39201 11.5859 7.01672 10.8388 7.96264 10.6557ZM5.7103 18.6256L8.39555 21.9337L8.39555 34.5597L5.7103 34.5597L5.7103 18.6256ZM5.7103 35.9682L8.39555 35.9682L8.39555 43.9349L5.7103 47.2438L5.7103 35.9682Z",
    fill: "#C4C4C4"
  })
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 3,
  class: "border-r border-solid border-gray-300 bay-iceing"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  width: "35",
  height: "56",
  viewBox: "0 0 35 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.0278106 13.6968C0.0948265 14.0621 0.0786503 13.9741 0.18187 14.5216C0.229629 14.7817 0.289712 15.0983 0.80196 15.0024C1.58073 14.861 2.96418 14.4054 3.52265 14.2003C3.57965 14.1776 3.63665 14.1571 3.6952 14.1375L3.6952 50.4278C3.6952 51.629 5.0386 56 9.53713 56L26.7186 56C30.9406 56 31.2087 51.629 31.2087 50.4278L31.2087 14.1037C31.2988 14.1359 31.3889 14.1666 31.476 14.2003C32.0352 14.4062 33.4179 14.8618 34.1974 15.0024C34.7105 15.0983 34.7705 14.7817 34.8191 14.5216C34.9207 13.9741 34.9038 14.0621 34.9724 13.6968C35.2782 12.0627 32.9727 11.8569 32.9727 11.8569L31.1324 11.4995C30.8289 8.00438 29.407 -0.000779484 23.0066 -0.000779204L11.8966 -0.000778718C6.05077 -0.000778463 4.26984 8.01696 3.82384 11.5081L2.0275 11.8577C2.0275 11.8577 -0.277227 12.0627 0.0278106 13.6968ZM26.1255 51.4451C23.4079 51.9668 11.5946 51.9668 8.87622 51.4451C8.26922 51.3289 7.87021 50.8497 7.97805 50.4129C8.30928 49.0059 8.63974 47.5997 8.97251 46.1943L26.03 46.1943C26.362 47.5997 26.6917 49.0059 27.0237 50.4129C27.1307 50.8497 26.7302 51.3289 26.1255 51.4451ZM29.2891 47.2438L26.6038 43.9349L26.6038 35.9675L29.2891 35.9675L29.2891 47.2438ZM29.2891 34.5597L26.6038 34.5597L26.6038 21.9337L29.2891 18.6256L29.2891 34.5597ZM23.0512 1.41721C25.4723 1.41721 26.828 2.98604 27.5806 4.96572C27.4727 5.23675 27.2879 5.47321 26.7579 5.29567C25.7789 4.96572 24.0788 4.11964 23.3932 3.74413C22.616 3.32227 21.6416 2.96796 21.352 1.41721L23.0512 1.41721ZM11.9489 1.41721L13.6482 1.41721C13.3593 2.96796 12.3842 3.32227 11.6069 3.74413C10.9206 4.11964 9.22054 4.96572 8.24226 5.29567C7.7123 5.474 7.5282 5.23675 7.41804 4.96572C8.17216 2.98604 9.52943 1.41721 11.9489 1.41721ZM7.96264 10.6557C12.2108 9.84423 22.7886 9.84423 27.036 10.6557C27.9827 10.838 28.6074 11.5859 28.4395 12.2725C27.911 14.5138 27.3842 16.7566 26.855 19.0011C26.6878 19.6845 26.0038 20.1033 25.3198 19.9728C22.2062 19.3758 12.794 19.3758 9.67887 19.9728C8.99561 20.1033 8.31236 19.6845 8.14366 19.0011C7.61524 16.7574 7.08682 14.5138 6.55916 12.2725C6.39201 11.5859 7.01672 10.8388 7.96264 10.6557ZM5.7103 18.6256L8.39555 21.9337L8.39555 34.5597L5.7103 34.5597L5.7103 18.6256ZM5.7103 35.9682L8.39555 35.9682L8.39555 43.9349L5.7103 47.2438L5.7103 35.9682Z",
    fill: "#92400E"
  })
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 4,
  class: "border-r border-solid border-gray-300 bay-hog flex items-center justify-center"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  width: "35",
  height: "56",
  viewBox: "0 0 35 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.0278106 13.6968C0.0948265 14.0621 0.0786503 13.9741 0.18187 14.5216C0.229629 14.7817 0.289712 15.0983 0.80196 15.0024C1.58073 14.861 2.96418 14.4054 3.52265 14.2003C3.57965 14.1776 3.63665 14.1571 3.6952 14.1375L3.6952 50.4278C3.6952 51.629 5.0386 56 9.53713 56L26.7186 56C30.9406 56 31.2087 51.629 31.2087 50.4278L31.2087 14.1037C31.2988 14.1359 31.3889 14.1666 31.476 14.2003C32.0352 14.4062 33.4179 14.8618 34.1974 15.0024C34.7105 15.0983 34.7705 14.7817 34.8191 14.5216C34.9207 13.9741 34.9038 14.0621 34.9724 13.6968C35.2782 12.0627 32.9727 11.8569 32.9727 11.8569L31.1324 11.4995C30.8289 8.00438 29.407 -0.000779484 23.0066 -0.000779204L11.8966 -0.000778718C6.05077 -0.000778463 4.26984 8.01696 3.82384 11.5081L2.0275 11.8577C2.0275 11.8577 -0.277227 12.0627 0.0278106 13.6968ZM26.1255 51.4451C23.4079 51.9668 11.5946 51.9668 8.87622 51.4451C8.26922 51.3289 7.87021 50.8497 7.97805 50.4129C8.30928 49.0059 8.63974 47.5997 8.97251 46.1943L26.03 46.1943C26.362 47.5997 26.6917 49.0059 27.0237 50.4129C27.1307 50.8497 26.7302 51.3289 26.1255 51.4451ZM29.2891 47.2438L26.6038 43.9349L26.6038 35.9675L29.2891 35.9675L29.2891 47.2438ZM29.2891 34.5597L26.6038 34.5597L26.6038 21.9337L29.2891 18.6256L29.2891 34.5597ZM23.0512 1.41721C25.4723 1.41721 26.828 2.98604 27.5806 4.96572C27.4727 5.23675 27.2879 5.47321 26.7579 5.29567C25.7789 4.96572 24.0788 4.11964 23.3932 3.74413C22.616 3.32227 21.6416 2.96796 21.352 1.41721L23.0512 1.41721ZM11.9489 1.41721L13.6482 1.41721C13.3593 2.96796 12.3842 3.32227 11.6069 3.74413C10.9206 4.11964 9.22054 4.96572 8.24226 5.29567C7.7123 5.474 7.5282 5.23675 7.41804 4.96572C8.17216 2.98604 9.52943 1.41721 11.9489 1.41721ZM7.96264 10.6557C12.2108 9.84423 22.7886 9.84423 27.036 10.6557C27.9827 10.838 28.6074 11.5859 28.4395 12.2725C27.911 14.5138 27.3842 16.7566 26.855 19.0011C26.6878 19.6845 26.0038 20.1033 25.3198 19.9728C22.2062 19.3758 12.794 19.3758 9.67887 19.9728C8.99561 20.1033 8.31236 19.6845 8.14366 19.0011C7.61524 16.7574 7.08682 14.5138 6.55916 12.2725C6.39201 11.5859 7.01672 10.8388 7.96264 10.6557ZM5.7103 18.6256L8.39555 21.9337L8.39555 34.5597L5.7103 34.5597L5.7103 18.6256ZM5.7103 35.9682L8.39555 35.9682L8.39555 43.9349L5.7103 47.2438L5.7103 35.9682Z",
    fill: "#E11D48"
  })
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 5,
  class: "flex items-center mb-6 mt-3"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-blue-800 text-xl" }, "Occupied", -1)
const _hoisted_21 = {
  key: 6,
  class: "flex items-center mb-6 mt-3"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-green-800 text-2xl" }, "Charging ", -1)
const _hoisted_23 = {
  key: 7,
  class: "flex items-center mb-6 mt-3"
}
const _hoisted_24 = {
  key: 8,
  class: "text-yellow-800 flex font-medium my-3"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl" }, "Iceing", -1)
const _hoisted_26 = {
  key: 9,
  class: "flex items-center mb-6 mt-3 text-red-700"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "bg-red-700 w-3 h-[0.75rem] mr-3 rounded-full inline-flex items-center justify-center" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl" }, "Bay Hogging", -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { key: 10 }
const _hoisted_31 = { class: "flex" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Duration")
const _hoisted_33 = {
  key: 0,
  class: "font-semibold text-2xl"
}

import { StationBay } from '@/types/interface';
import { computed } from 'vue';
import {
  LightningBoltIcon,
  ExclamationIcon,
  ClockIcon,
  MinusCircleIcon,
} from '@heroicons/vue/solid';
import { formatTime } from '@/utils/dateTimeFormat';


export default /*#__PURE__*/_defineComponent({
  props: {
    station: null
  },
  setup(__props: any) {

const props = __props as {
  station: StationBay[];
}



const sortStation = computed(() => {
  return props.station.sort(function (a, b) {
    return a.bayId - b.bayId;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", _hoisted_1, " Station " + _toDisplayString(_unref(sortStation)[0].stationId), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortStation), (bay) => {
        return (_openBlock(), _createElementBlock("div", {
          key: bay?.id,
          class: ""
        }, [
          _createElementVNode("p", _hoisted_3, "Bay " + _toDisplayString(bay.bayId), 1),
          (
            !bay.charging &&
            !bay.available &&
            !bay.icingIncident &&
            !bay.bayHoggingIncident
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
            : (bay.charging)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : (bay.available)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                : (bay.icingIncident)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                  : (bay.bayHoggingIncident)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                    : _createCommentVNode("", true),
          (
            !bay.charging &&
            !bay.available &&
            !bay.icingIncident &&
            !bay.bayHoggingIncident
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(_unref(MinusCircleIcon), { class: "h-5 w-5 text-blue-800 mr-2" }),
                _hoisted_20
              ]))
            : (bay.charging)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createVNode(_unref(LightningBoltIcon), { class: "h-5 w-5 text-green-600 mr-2" }),
                  _hoisted_22
                ]))
              : (bay.available)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23))
                : (bay.icingIncident)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createVNode(_unref(ExclamationIcon), { class: "h-5 w-5 mr-4" }),
                      _hoisted_25
                    ]))
                  : (bay.bayHoggingIncident)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_29))
                    : _createCommentVNode("", true),
          (bay?.duration && !bay?.available)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("p", _hoisted_31, [
                  _createVNode(_unref(ClockIcon), { class: "h-5 w-5 mr-2" }),
                  _hoisted_32
                ]),
                (bay?.duration)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_unref(formatTime)(bay.duration).hours) + "h " + _toDisplayString(_unref(formatTime)(bay.duration).minutes) + "m ", 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})